import zsmLayout from '@/zsm-layout'

const complaintsRouter = {
  path: '/dist',
  component: zsmLayout,
  name: 'distribution',
  redirect: '/dist/list',
  children: [
    {
      path: '/mountscope',
      component: () => import('@/view/mountscope/index'),
      hidden: true,
      name: 'mountscope'
    },
    {
      path: '/certification',
      name: 'certification',
      redirect: '/certification/home',
      component: () => import('@/view/certification/index'),
      children: [
        {
          path: '/certification/person',
          component: () => import('@/view/certification/person'),
          name: 'certificationPerson'
        },
        {
          path: '/certification/company',
          component: () => import('@/view/certification/company'),
          name: 'certificationCompany'
        },
        {
          path: '/certification/home',
          component: () => import('@/view/certification/home'),
          name: 'certificationCompany'
        },
        {
          path: '/certification/type',
          component: () => import('@/view/certification/type'),
          name: 'certificationCompany'
        }
      ]
    }
  ]
}

export default complaintsRouter
